import { html, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import { UIModalServiceModal } from '../../../../app/package/base/service/modals/modal-service';
import { I18n } from '../../../base/package/services/package/i18n/i18n.de';
import type { UIModal } from '../../ui-modal/ui-modal';
import styles from './ui-confirm-location-modal.css?inline';

const CName = 'ui-confirm-location-modal';

@customElement(CName)
export class UIConfirmLocationModal extends UIModalServiceModal {
  static readonly styles = unsafeCSS(styles);
  public onCloseCallback?: (el: UIModal) => void;
  public onActionCallback?: (el: UIModal) => void;

  private _isConfirmed = false;
  private _shownTrackingFired = false;
  private _closeTrackingFired = false;
  private _closeAltTrackingFired = false;

  public close() {
    if (!this._isConfirmed) {
      if (!this._closeTrackingFired) {
        this._closeTrackingFired = true;
        this._trackEvent('sh_location_confirmation_popup_not_SH_user');
      }
      this.onCloseCallback?.(this._modalRef.value!);
    }
    this._modalRef.value?.close();
  }

  connectedCallback(): void {
    super.connectedCallback();
    if (!this._shownTrackingFired) {
      this._shownTrackingFired = true;
      this._trackEvent('sh_location_confirmation_popup_shown');
    }
  }

  render() {
    return html`
      <ui-modal
        ${ref(this._modalRef)}
        .onAction=${(el: UIModal) => {
          this._isConfirmed = true;
          if (!this._closeAltTrackingFired) {
            this._closeAltTrackingFired = true;
            this._trackEvent('sh_location_confirmation_popup_SH_user');
          }
          this.onActionCallback?.(el);
          el.close();
        }}
        .actionButtonLabel=${I18n.compliance.confirmLocationModal.actionButtonText}
        .onAltAction=${() => this.close()}
        .altActionButtonLabel=${I18n.compliance.confirmLocationModal.altActionButtonText}
        .onClosedAction=${() => this.close()}
        class="modal--centered"
      >
        <div slot="icon" class="icon">
          <ui-pin-icon></ui-pin-icon>
        </div>
        <div slot="title">${I18n.compliance.confirmLocationModal.title}</div>
        <div class="content" slot="main">
          <div>${I18n.compliance.confirmLocationModal.text}</div>
        </div>
      </ui-modal>
    `;
  }

  private _trackEvent(
    eventAction:
      | 'sh_location_confirmation_popup_shown'
      | 'sh_location_confirmation_popup_SH_user'
      | 'sh_location_confirmation_popup_not_SH_user',
  ) {
    window.$app.track.customEvent({
      event: 'gamesSH',
      eventAction,
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIConfirmLocationModal;
  }
}
